import { useNavigate } from "react-router-dom";
import { useCombinedInvitations } from "../../org/hooks/OrgInvite/useCombinedInvitations";
import { IconButton } from "@datapay-by-datacom/design-system";
import { IoNotificationsOutline } from "react-icons/io5";
import s from "./NotificationAlert.module.css";

export function NotificationAlert() {
  const { allInvitations } = useCombinedInvitations();
  const navigate = useNavigate();
  const pendingCount = allInvitations.length;

  if (pendingCount === 0) {
    return null;
  }

  return (
    <div className={s.alertContainer}>
      <IconButton
        className={s.alertButton}
        onPress={() => navigate("/notifications")}
      >
        <IoNotificationsOutline size={20} />
        {pendingCount > 0 && (
          <span className={s.badge}>
            {pendingCount > 9 ? "9+" : pendingCount}
          </span>
        )}
      </IconButton>
    </div>
  );
}
